@if (!noPreview) {
<div>
  <div class="options">
    @if (!disabled) {
    <inline-options>
      <a (click)="showPreview()" [class.active]="!editable">preview</a>
      <a (click)="showInput()" [class.active]="editable">edit</a>
    </inline-options>
    } @if (disabled) {
    <inline-options>
      <span class="active">preview</span>
      <span>edit</span>
    </inline-options>
    }
  </div>
  <div>
    @if (!editable) {
    <div #preview class="preview" [innerHTML]="html | safeHtml"></div>
    } @else {
    <div class="NgxEditor__Wrapper" [ngStyle]="{ minHeight: minHeight }">
      @if (showMenu) {
      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
      }
      <ngx-editor
        id="ngx-editor"
        outputFormat="html"
        [editor]="editor"
        [ngModel]="html"
        [disabled]="disabled"
        [placeholder]="placeholder"
        (blur)="touch.emit()"
        (ngModelChange)="valueChange.emit($event)"
      ></ngx-editor>
    </div>
    }
  </div>
</div>
} @if (noPreview) {
<div class="NgxEditor__Wrapper" [ngStyle]="{ minHeight: minHeight }">
  @if (showMenu) {
  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
  }
  <ngx-editor
    id="ngx-editor-nopreview"
    outputFormat="html"
    [editor]="editor"
    [ngModel]="html"
    [disabled]="disabled"
    [placeholder]="placeholder"
    (blur)="touch.emit()"
    (ngModelChange)="valueChange.emit($event)"
  ></ngx-editor>
</div>
}
